import { blue, blueGrey, red } from '@mui/material/colors';

import { metaTagBackgroundColor, metaTagBackgroundDarkMode, metaTagColor } from '/shared/TableMeta';

export const tagColor = {
  isMeta: {
    color: metaTagColor,
    backgroundColor: metaTagBackgroundColor,
    backgroundColorDark: metaTagBackgroundDarkMode,
  },
  require: {
    icon: red.A400,
    backgroundColor: red.A200,
  },
  creation: {
    backgroundColor: blueGrey[500],
  },
  other: {
    icon: blue.A400,
    backgroundColor: blue.A200,
  },
};
